export default "__VITE_ASSET__Be8vXF5Q__"